import { useState } from "react";
import Editor from "../../../../../Editor/Editor";
import clsx from "clsx";
import treeStyles from "../treeStyles.module.css";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface TreeSearchProps {
  visible: boolean;
  onEdit: (val: string) => void;
}

export default function TreeSearch({ onEdit, visible }: TreeSearchProps) {
  if (!visible) return <></>;

  const [searchVal, setSearchVal] = useState("");
  return (
    <div className={clsx(treeStyles.treeSearch)}>
      <Editor
        placeholderVisible="1"
        placeholder="Поиск по категориям..."
        name="treeSearch"
        onEdit={(data: { value: string }) => {
          setSearchVal(data.value);
        }}
      />
      <IconButton
        onClick={() => {
          onEdit(searchVal);
        }}
      >
        <SearchIcon style={{ fontSize: "15px" }} />
      </IconButton>
    </div>
  );
}
